import script from "./trayRedcodeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./trayRedcodeTable.vue?vue&type=script&setup=true&lang=js"

import "./trayRedcodeTable.vue?vue&type=style&index=0&id=025ccfae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025ccfae"]])

export default __exports__